import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2 0h9a1 1 0 0 1 .763 1.646l-1.979 2.34 1.98 2.339A1 1 0 0 1 11 7.97H2V16H0V0h2zm0 2v3.97h6.844L7.71 4.631a1 1 0 0 1 0-1.292L8.844 2H2z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-flag"}) } }